var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"noticia-container"},[_c('NoticiaComponente',{attrs:{"noticia":_vm.noticia,"mancheta":true,"contenido":true}})],1),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br')])}
var staticRenderFns = []

export { render, staticRenderFns }